import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchItem from "./SearchItem.js";
import Close from "../../../Assets/Modals/closeIcon.svg";
import Search from "../../../Assets/Modals/SearchIcon.svg";
import RemoveIcon from "../../../Assets/Modals/RemoveIcon.js";
import CrossCircular from "../../../Assets/Modals/CrossCircular.svg";

import {
    clearList,
    closeModal,
    removeFilter,
    addFilter,
    updateSearchList,
    clearFilters,
} from "../../../Features/searchSlice.js";
import { useOutsideClickHandler } from "../../../Hooks/useOutsideClick.js";
import { apiV1 } from "../../../Auth/Interceptor.js";

const filters = [
    {
        name: "Product",
        id: "Product",
        filterName: 'Product',
        text: "text-[#991B1B]",
        bg: "bg-[#FEE2E2]",
        stroke: "#F87171",
    },
    {
        name: 'Order ID',
        id: 'orderID',
        filterName: 'Order Id',
        text: 'text-[#5B21B6]',
        bg: 'bg-[#EDE9FE]',
        stroke: '#818CF8'
    },
    {
        name: "SKU Code",
        id: "SKU Code",
        filterName: 'SKU',
        text: "text-[#065F46]",
        bg: "bg-[#D1FAE5]",
        stroke: "#34D399",
    },
    {
        name: "Category Collection",
        id: "Category Collection",
        filterName: 'Category Collection',
        text: "text-[#3730A3]",
        bg: "bg-[#E0E7FF]",
        stroke: "#818CF8",
    },
    {
        name: "Custom Collection",
        id: "Custom Collection",
        filterName: 'Custom Collection',
        text: "text-[#92400E]",
        bg: "bg-[#FEF3C7]",
        stroke: "#FBBF24",
    },
    {
        name: 'Coupon',
        id: 'coupon',
        filterName: 'Coupon',
        text: 'text-[#9D174D]',
        bg: 'bg-[#FCE7F3]',
        stroke: '#F472B6'
    },
];

const getSearchItemTitle = (searchItem) => {
    switch (searchItem.source) {
        case 'Product': 
            return searchItem.productName;
        case 'Order Id': 
            return searchItem.orderId;
        case 'SKU': 
            return searchItem.productSKU;
        case 'Collection': 
            return searchItem.CollectionName;
        case 'Category Collection': 
            return searchItem.CollectionName;
        case 'Custom Collection': 
            return searchItem.CollectionName;
        case 'Coupon': 
            return searchItem.couponName;
        default: 
            return '';
    }
}

function Modal() {
    const dispatch = useDispatch();
    const filtersList = useSelector((state) => state.search.filters);
    const searchList = useSelector((state) => state.search.searchList);
    const wrapperRef = useRef(null);

    const [searchValue, setSearchValue] = useState("");

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const clearSearchString = () => {
        setSearchValue("");
    };

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    useEffect(() => {
        const handleKeyPress = async (event) => {
            if (event.key === "Enter") {
                if (searchValue.trim().length) {
                    const params = {
                        val: searchValue,
                        filters: [ ...filtersList ],
                    };

                    let API_URL = "search?val=" + encodeURIComponent(searchValue);

                    if (params.filters && params.filters.length > 0) {
                        params.filters.forEach((filter) => {
                            API_URL += "&filters=" + encodeURIComponent(filter);
                        });
                    }

                    await apiV1.get(API_URL)
                    .then((response) => {
                        dispatch(updateSearchList(response.data.data));
                    })
                    .catch((error) => {
                        alert("Error:", error);
                    });
                }
                else {
                    dispatch(clearList());
                }
            }
        };

        document.addEventListener("keypress", handleKeyPress);

        return () => {
            document.removeEventListener("keypress", handleKeyPress);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue, filtersList]);

    return (
        <div className="fixed z-50 size-full top-0 left-0 bg-[#00000080] flex justify-center items-center">
            <div
                ref={wrapperRef}
                className="w-4/5 h-[620px] bg-[#FFFFFF] rounded-xl px-6 pt-6 flex flex-col gap-3 shadow-[0px_0px_12px_0px_#0000003D]"
            >
                <div className="flex items-center justify-between">
                    <h1 className="font-semibold text-2xl text-[#121212] select-none">
                        Search
                    </h1>

                    <button className="outline-none select-none" onClick={handleCloseButtonClick}>
                        <img src={Close} alt="Close Modal" />
                    </button>
                </div>

                <div className="flex items-center gap-1 mt-3 p-4 border border-[#EAEAEA] bg-[#F5F5F5] rounded-lg">
                    <div className="size-6 flex items-center justify-center">
                        <img src={Search} alt="" />
                    </div>

                    <input
                        id="search-input"
                        value={searchValue}
                        onChange={handleChange}
                        className={`font-medium text-base text-[#121212] ${
                        searchValue.length ? "w-[calc(100%-48px)]" : "w-[calc(100%-24px)]"
                        } outline-none border-none bg-transparent`}
                        type="text"
                    />

                    {searchValue && (
                        <div
                            onClick={clearSearchString}
                            className="cursor-pointer size-6 flex items-center justify-center"
                        >
                            <img src={CrossCircular} alt="" />
                        </div>
                    )}
                </div>

                <div className="flex flex-col gap-2 h-full overflow-hidden">
                    <div className="flex flex-col gap-1">
                        <h1 className="text-[14px] leading-[22px] font-medium text-[#666666]">Filter by</h1>

                        <div className="flex items-center gap-3">
                            {filters.map((item) => {
                                return (
                                    <span
                                        key={item.id}
                                        onClick={() => {dispatch(addFilter(item.filterName));}}
                                        className={`${
                                        filtersList?.includes(item.filterName)
                                            ? `${item.text} ${item.bg}`
                                            : "bg-[#F5F5F5] text-[#121212]"
                                        } select-none flex items-center gap-[2px] cursor-pointer px-3 py-1 rounded-lg font-normal text-[12px] leading-6`}
                                    >
                                        {item.name}
                                        {filtersList?.includes(item.filterName) && (
                                            <div className="p-1 flex items-center justify-center">
                                                <RemoveIcon
                                                    onClick={() => {dispatch(removeFilter(item.filterName));}}
                                                    stroke={item.stroke}
                                                />
                                            </div>
                                        )}
                                    </span>
                                );
                            })}

                            <button
                                onClick={() => {dispatch(clearFilters());}}
                                className="outline-none border-none select-none cursor-pointer underline text-[14px] leading-6 text-[#6572E8]"
                            >
                                Clear Filters
                            </button>
                        </div>
                    </div>

                    <div className="flex flex-col gap-1 max-h-full overflow-y-scroll">
                        <h1 className="font-medium text-[16px] leading-8 text-[#666666]">
                            {
                                searchList.length
                                ? `Search Results (${searchList?.length})`
                                : "Recent Search"
                            }
                        </h1>

                        <div className="flex flex-col gap-1">
                            {searchList?.map((item, index) => {
                                const matchingFilter = filters.find((filter) => {
                                        if (item.source === 'Collection') {
                                            return filter.filterName === 'Category Collection';
                                        }
                                        else {
                                            return filter.filterName === item.source;
                                        }
                                    }
                                );

                                const title = getSearchItemTitle(item);

                                return (
                                    <SearchItem
                                        key={index} 
                                        searchItem={item}
                                        category={matchingFilter?.name}
                                        text={matchingFilter?.text}
                                        bg={matchingFilter?.bg} 
                                        title={title} 
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;
